import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon, ActivityIcon, MoonIcon } from 'lucide-react';
const pillars = [{
  icon: UtensilsIcon,
  title: 'Nutrición Consciente',
  description: 'Alimentación placentera que nutre sin restricciones.'
}, {
  icon: ActivityIcon,
  title: 'Movimiento Inteligente',
  description: 'Rutinas que energizan en lugar de agotar.'
}, {
  icon: MoonIcon,
  title: 'Descanso Reparador',
  description: 'Hábitos nocturnos para despertar renovada.'
}];
export function Mechanism() {
  return <section className="py-24 lg:py-32 bg-[var(--color-cream)]" data-id="element-112">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-114">
          <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto" data-id="element-115">
            {pillars.map((pillar, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.2
          }} className="text-center flex flex-col items-center" data-id="element-116">
                <div className="bg-[var(--color-pale-pink)] rounded-full w-24 h-24 flex items-center justify-center mb-8 shadow-sm" data-id="element-117">
                  <pillar.icon className="w-10 h-10 text-[var(--color-dark-sage)]" strokeWidth={1.5} data-id="element-118" />
                </div>
                <h3 className="text-2xl font-bold text-[var(--color-charcoal)] mb-4" data-id="element-119">
                  {pillar.title}
                </h3>
                <p className="text-lg text-[var(--color-charcoal)] opacity-70 font-light leading-relaxed" data-id="element-120">
                  {pillar.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}